 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AcceptedRequests~RefusedRequests":"AcceptedRequests~RefusedRequests","AcceptedRequests":"AcceptedRequests","RefusedRequests":"RefusedRequests","ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors":"ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors","ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors":"ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors","ApprovedTutors":"ApprovedTutors","NewTutors":"NewTutors","RejectedTutors":"RejectedTutors","TerminatedTutors":"TerminatedTutors","UnderReviewTutors":"UnderReviewTutors","GroupClasses":"GroupClasses","StudentsListView":"StudentsListView","AssignStudent":"AssignStudent","AssignStudentGroup":"AssignStudentGroup","BookedClasses":"BookedClasses","BookedWebinars":"BookedWebinars","ContactUsList":"ContactUsList","CoursesManagement":"CoursesManagement","CoursesView":"CoursesView","CurrentClasses":"CurrentClasses","ForgetPassword":"ForgetPassword","Homework":"Homework","Login":"Login","Meeting":"Meeting","OperatorLogin":"OperatorLogin","OperatorWebinars":"OperatorWebinars","PaymentView":"PaymentView","Profile":"Profile","ProgramsView":"ProgramsView","QuestionsView":"QuestionsView","QuizView~StudentQuizzes":"QuizView~StudentQuizzes","QuizView":"QuizView","StudentQuizzes":"StudentQuizzes","Register":"Register","RescheduleRequests":"RescheduleRequests","SessionsView":"SessionsView","StudentArchivedClasses":"StudentArchivedClasses","StudentClasses":"StudentClasses","StudentGroupsDetails":"StudentGroupsDetails","StudentsGroups":"StudentsGroups","SubAccounts":"SubAccounts","TutorArchivedClasses":"TutorArchivedClasses","TutorsView":"TutorsView","UpdatePassword":"UpdatePassword","about":"about","fancyHome":"fancyHome","linkedIn":"linkedIn","resetpassword":"resetpassword","verifyemail":"verifyemail"}[chunkId]||chunkId) + "." + {"AcceptedRequests~RefusedRequests":"a3f2f105","AcceptedRequests":"998b8d0f","RefusedRequests":"da7eca7c","ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors":"b9cfed8f","ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors":"581b17fa","ApprovedTutors":"1f35c673","NewTutors":"2a37d6c6","RejectedTutors":"9379528a","TerminatedTutors":"39b4efac","UnderReviewTutors":"9c1a7076","GroupClasses":"ee100d4c","StudentsListView":"67ee8293","AssignStudent":"33e3290b","AssignStudentGroup":"43a8496d","BookedClasses":"05910187","BookedWebinars":"c8ba18ea","ContactUsList":"0b6dfca8","CoursesManagement":"5dc71937","CoursesView":"f465477b","CurrentClasses":"a5a27f8b","ForgetPassword":"71ce8a35","Homework":"465af4dd","Login":"74393419","Meeting":"bfc90312","OperatorLogin":"68b4ef06","OperatorWebinars":"759356b9","PaymentView":"a6da8cea","Profile":"7f83e6ba","ProgramsView":"e6f0feb1","QuestionsView":"07dc2c00","QuizView~StudentQuizzes":"cf9b1cb2","QuizView":"c562493d","StudentQuizzes":"ac577ddd","Register":"8b12f3b7","RescheduleRequests":"825adbdf","SessionsView":"8a6c3fb0","StudentArchivedClasses":"7b1e0723","StudentClasses":"84a7659d","StudentGroupsDetails":"534d50ea","StudentsGroups":"9ce4efc5","SubAccounts":"7d192bd0","TutorArchivedClasses":"1a92ba43","TutorsView":"96de4d18","UpdatePassword":"642db169","about":"8d46804c","chunk-12161498":"e70ed526","fancyHome":"976b9ae5","linkedIn":"bdf748cf","resetpassword":"e2998605","verifyemail":"ea368ce2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AcceptedRequests~RefusedRequests":1,"ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors":1,"ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors":1,"GroupClasses":1,"StudentsListView":1,"AssignStudentGroup":1,"BookedClasses":1,"BookedWebinars":1,"ContactUsList":1,"CoursesManagement":1,"CoursesView":1,"CurrentClasses":1,"Homework":1,"Meeting":1,"OperatorLogin":1,"OperatorWebinars":1,"PaymentView":1,"Profile":1,"ProgramsView":1,"QuizView~StudentQuizzes":1,"QuizView":1,"Register":1,"RescheduleRequests":1,"SessionsView":1,"StudentArchivedClasses":1,"StudentClasses":1,"StudentsGroups":1,"SubAccounts":1,"TutorArchivedClasses":1,"TutorsView":1,"about":1,"chunk-12161498":1,"fancyHome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AcceptedRequests~RefusedRequests":"AcceptedRequests~RefusedRequests","AcceptedRequests":"AcceptedRequests","RefusedRequests":"RefusedRequests","ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors":"ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors","ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors":"ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors","ApprovedTutors":"ApprovedTutors","NewTutors":"NewTutors","RejectedTutors":"RejectedTutors","TerminatedTutors":"TerminatedTutors","UnderReviewTutors":"UnderReviewTutors","GroupClasses":"GroupClasses","StudentsListView":"StudentsListView","AssignStudent":"AssignStudent","AssignStudentGroup":"AssignStudentGroup","BookedClasses":"BookedClasses","BookedWebinars":"BookedWebinars","ContactUsList":"ContactUsList","CoursesManagement":"CoursesManagement","CoursesView":"CoursesView","CurrentClasses":"CurrentClasses","ForgetPassword":"ForgetPassword","Homework":"Homework","Login":"Login","Meeting":"Meeting","OperatorLogin":"OperatorLogin","OperatorWebinars":"OperatorWebinars","PaymentView":"PaymentView","Profile":"Profile","ProgramsView":"ProgramsView","QuestionsView":"QuestionsView","QuizView~StudentQuizzes":"QuizView~StudentQuizzes","QuizView":"QuizView","StudentQuizzes":"StudentQuizzes","Register":"Register","RescheduleRequests":"RescheduleRequests","SessionsView":"SessionsView","StudentArchivedClasses":"StudentArchivedClasses","StudentClasses":"StudentClasses","StudentGroupsDetails":"StudentGroupsDetails","StudentsGroups":"StudentsGroups","SubAccounts":"SubAccounts","TutorArchivedClasses":"TutorArchivedClasses","TutorsView":"TutorsView","UpdatePassword":"UpdatePassword","about":"about","fancyHome":"fancyHome","linkedIn":"linkedIn","resetpassword":"resetpassword","verifyemail":"verifyemail"}[chunkId]||chunkId) + "." + {"AcceptedRequests~RefusedRequests":"321c5368","AcceptedRequests":"31d6cfe0","RefusedRequests":"31d6cfe0","ApprovedTutors~GroupClasses~NewTutors~RejectedTutors~StudentsListView~TerminatedTutors~UnderReviewTutors":"8a0f9d68","ApprovedTutors~NewTutors~RejectedTutors~TerminatedTutors~UnderReviewTutors":"e317f0e7","ApprovedTutors":"31d6cfe0","NewTutors":"31d6cfe0","RejectedTutors":"31d6cfe0","TerminatedTutors":"31d6cfe0","UnderReviewTutors":"31d6cfe0","GroupClasses":"e09003b9","StudentsListView":"36be7160","AssignStudent":"31d6cfe0","AssignStudentGroup":"8d749eef","BookedClasses":"01903e64","BookedWebinars":"e9d7eefe","ContactUsList":"2242cf30","CoursesManagement":"a12f3a98","CoursesView":"5da3558d","CurrentClasses":"35fd8fce","ForgetPassword":"31d6cfe0","Homework":"1123a12b","Login":"31d6cfe0","Meeting":"34d55927","OperatorLogin":"c041568b","OperatorWebinars":"8cf46408","PaymentView":"286d8590","Profile":"bf319e00","ProgramsView":"9b3eee9f","QuestionsView":"31d6cfe0","QuizView~StudentQuizzes":"9273a5f8","QuizView":"bf535053","StudentQuizzes":"31d6cfe0","Register":"928f2245","RescheduleRequests":"6589705b","SessionsView":"6df57e3d","StudentArchivedClasses":"17ab4af2","StudentClasses":"cdfcc74d","StudentGroupsDetails":"31d6cfe0","StudentsGroups":"52c78b64","SubAccounts":"ffb494d4","TutorArchivedClasses":"5876a23c","TutorsView":"43f1a5bc","UpdatePassword":"31d6cfe0","about":"7e20cbf5","chunk-12161498":"f879a8ec","fancyHome":"2ee6c493","linkedIn":"31d6cfe0","resetpassword":"31d6cfe0","verifyemail":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
